module.exports = __webpack_public_path__ + "static/dmon-014-d374f863897c4fa21bfe0cca1b443738.jpg";